import React from 'react';

import {
  DadosSolicitacaoContainer,
  Header,
  Body,
  Cabecalho,
  AssuntoContainer,
  Footer,
} from './styles';

import { ReactComponent as Home } from '../../../assets/novosicones/Solicitacoes/home.svg';

import { ReactComponent as Calendar } from '../../../assets/calendar.svg';

import { ReactComponent as AberturaIcon } from '../../../assets/novosicones/Solicitacoes/sticky_note_2_black_24dp (1).svg';

import { ReactComponent as ClassificacaoIcon } from '../../../assets/novosicones/Solicitacoes/list_black_24dp.svg';

import { ReactComponent as AcompanhamentoIcon } from '../../../assets/novosicones/Solicitacoes/list_alt_black_24dp.svg';

import { ReactComponent as ProtocoloIcon } from '../../../assets/novosicones/Solicitacoes/local_activity_black_24dp.svg';

import formatDate from '../../../Utils/formatDate';

import ItemCabecalhoComponent from './ItemCabecalho';

import AlertMessage from '../AlertMessage';

// import scheduleTime from "../../../Utils/horario";
import scheduleTime from '../../../Utils/schedTime';
import AttachDocuments from '../NovaSolicitacao/AttachDocuments';

import RespostaSolicitacao from './RespostaSolicitacao';

const DadosSolicitacao = ({
  solicitacao,
  editarSolicitacao,
  tema,
  confirmarSolicitacao,
  respostaRef,
  isSindico,
}) => {
  const tiposSolicitacaoComAgendamento = [
    'Assistência Técnica',
    'Entrega de Unidade',
    'Vistoria',
  ];

  let estiloConfirmarSolicitacaoCabecalho = { width: '100%' };

  if (confirmarSolicitacao) {
    estiloConfirmarSolicitacaoCabecalho = {
      flexDirection: 'column',
    };
  }

  const showAlertMessage =
    !confirmarSolicitacao && solicitacao?.textoNotificacao;

  return (
    <>
      {showAlertMessage && (
        <AlertMessage
          alertTitle={solicitacao.fase}
          alertText={solicitacao.textoNotificacao}
        />
      )}
      <DadosSolicitacaoContainer>
        <Header color={tema?.primaryColor}>
          <span> Dados da solicitação:</span>
        </Header>
        <Body>
          <Cabecalho style={estiloConfirmarSolicitacaoCabecalho}>
            {!confirmarSolicitacao && (
              <ItemCabecalhoComponent
                title='Protocolo'
                info={solicitacao.caseNumber}
                icon={<ProtocoloIcon />}
                confirmarSolicitacao={confirmarSolicitacao}
                id={'caseNumber'}
              />
            )}
            <ItemCabecalhoComponent
              title='Abertura'
              info={formatDate(solicitacao.createdDate)}
              icon={<AberturaIcon />}
              confirmarSolicitacao={confirmarSolicitacao}
            />
            {((confirmarSolicitacao &&
              tiposSolicitacaoComAgendamento.includes(solicitacao.tipo)) ||
              !confirmarSolicitacao) && (
              <ItemCabecalhoComponent
                title='Agendamento:'
                info={scheduleTime(solicitacao)}
                icon={<Calendar />}
                confirmarSolicitacao={confirmarSolicitacao}
              />
            )}
            <ItemCabecalhoComponent
              title='Imóvel:'
              info={solicitacao.ativo}
              icon={<Home />}
              confirmarSolicitacao={confirmarSolicitacao}
            />
            <ItemCabecalhoComponent
              title='Classificação:'
              info={solicitacao.tipo}
              icon={<ClassificacaoIcon />}
              confirmarSolicitacao={confirmarSolicitacao}
            />
            {!confirmarSolicitacao && (
              <ItemCabecalhoComponent
                title='Acompanhamento:'
                info={solicitacao.fase ?? 'Não elegível'}
                icon={<AcompanhamentoIcon />}
                confirmarSolicitacao={confirmarSolicitacao}
              />
            )}
          </Cabecalho>
          {solicitacao?.subject && (
            <AssuntoContainer>
              <span>Assunto:</span>
              <p>{solicitacao?.subject}</p>
            </AssuntoContainer>
          )}

          {(!tiposSolicitacaoComAgendamento.includes(solicitacao.tipo) ||
            solicitacao?.tipo === 'Entrega de Unidade') && (
            <>
              <AssuntoContainer>
                <span>Descrição:</span>
                <p>{solicitacao?.description}</p>
              </AssuntoContainer>

              <AttachDocuments
                documents={solicitacao?.anexos}
                readOnly
                tema={tema}
                isSindico={isSindico}
              />
            </>
          )}
          {solicitacao?.tipo === 'Vistoria' && (
            <>
              <AssuntoContainer>
                <span>Descrição:</span>
                <p>{solicitacao?.description}</p>
              </AssuntoContainer>
            </>
          )}
        </Body>
        {solicitacao?.emailResponse && (
          <RespostaSolicitacao respostaRef={respostaRef} tema={tema}>
            {solicitacao?.emailResponse}
          </RespostaSolicitacao>
        )}
        {!editarSolicitacao &&
          !confirmarSolicitacao &&
          solicitacao?.tipo === 'Assistência Técnica' && (
            <Footer tema={tema}>
              <details open>
                <summary>Mais informações</summary>
                <div>
                  <p>
                    - Você pode incluir mais de uma patologia (reparo) na mesma
                    solicitação de Assistência Técnica;
                  </p>
                  {!isSindico && (
                    <p>
                      - Cada imóvel pode ter apenas um agendamento (de análise).
                      Neste deve conter todos os reparos necessários;
                    </p>
                  )}
                  <p>
                    - As solicitações podem receber alterações
                    (edições/exclusões) até 24 horas antes de seu agendamento;
                  </p>
                  <p>
                    - Caso após realizada a análise seja identificado outro item
                    que necessite de Assistência Técnica, favor abrir uma nova
                    solicitação;
                  </p>

                  {isSindico && (
                    <p>
                      - É fundamental que o responsável pela solicitação durante
                      o atendimento tenha no mínimo 18 anos e esteja com seus
                      documentos de identificação.
                    </p>
                  )}

                  {!isSindico && (
                    <p>
                      - É fundamental que o responsável pelo imóvel durante o
                      atendimento tenha no mínimo 18 anos e esteja com seus
                      documentos de identificação.
                    </p>
                  )}
                </div>
              </details>
            </Footer>
          )}
      </DadosSolicitacaoContainer>
    </>
  );
};

export default DadosSolicitacao;
